import { render, staticRenderFns } from "./InterconnectedBillingStatementsDetail.vue?vue&type=template&id=3f28c64b&scoped=true&"
import script from "./InterconnectedBillingStatementsDetail.vue?vue&type=script&lang=js&"
export * from "./InterconnectedBillingStatementsDetail.vue?vue&type=script&lang=js&"
import style0 from "./InterconnectedBillingStatementsDetail.vue?vue&type=style&index=0&id=3f28c64b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f28c64b",
  null
  
)

export default component.exports